// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2L_Sc","info":"PatientInfo_info__1dygK"};